import { ReqMethod as l } from "@larner.dev/req";
import { useState as d, useMemo as m } from "react";
const g = (a) => {
  const [u, s] = d({
    loading: !1,
    error: null,
    result: null
  });
  return [
    m(() => {
      const o = async (r, e, c) => {
        s({ error: null, loading: !0, result: null });
        try {
          const t = await a[r](e, c);
          return s({ error: null, loading: !1, result: t }), { success: !0, result: t };
        } catch (t) {
          const n = {
            message: t.message,
            code: t.code || "UNKNOWN",
            params: t.params || void 0
          };
          return s({
            error: n,
            loading: !1,
            result: null
          }), { success: !1, error: n };
        }
      };
      return {
        get: (r, e) => o(l.GET, r, e),
        post: (r, e) => o(l.POST, r, e),
        put: (r, e) => o(l.PUT, r, e),
        delete: (r, e) => o(l.DELETE, r, e)
      };
    }, [a]),
    {
      ...u,
      clearError: () => s({ ...u, error: null })
    }
  ];
};
export {
  g as useReq
};
